export default {
    // shared across editCard components
    ec_save: "Save",
    ec_cancel: "Cancel",
    ec_fail: "Fail",
    ec_failed_save: "Failed to save",
    ec_show: "Show:",
    ec_rotate_img: "Rotate Image",
    ec_position_y: "PositionY :",
    ec_position_x: "PositionX :",
    ec_zoom: "Zoom :",
    ec_not_available_plan: "Not available for your current plan",
    ec_premium_title: "This feature is available for PREMIUM USERS.",
    ec_premium_text: "Upgrade your App to Premium and advanced features, Please contact your administrator at support@marketea.com or Call us at 774-287-3353.",

    // editContact
    econt_find_me_at: "Find me at:",
    econt_contact_me: "Contact Me:",
    econt_title_form_ph: "Title form",

    // editInfo
    ei_about_me: "About me:",
    ei_name: "Name",
    ei_last_name: "Last Name",
    ei_position: "Position:",
    ei_url: "Url:",
    ei_edit: "Edit",
    ei_wrong_url: "Wrong url or already exist.",

    // editSchedule
    esched_hours: "Hours:",
    esched_open_prefix: "Open",
    esched_active: "Active",
    esched_closed: "Closed",
    esched_open_at: "Open at",
    esched_close_at: "Close at",

    // editMapIframe
    em_location: "Location",
    em_insert_map: "Insert Map",
    em_showcase: "ShowCase",
    em_insert_html: "Insert HTML map code here",
    em_or_get_one: "or get one",
    em_clear: "Clear",
    em_hide_map: "Hide Map",
    em_showcase_desc1: "This section allows you to create a visual presentation of your business.",
    em_showcase_desc2: "You can add 1 to 4 images along with descriptive content, which will be displayed as a small image slider.",
    em_tip: "Tip:",
    em_tip_text: "Use clear, high-quality images that accurately represent your business.",
    em_add_image: "Add Image",
    em_enabled: "Enabled",
    em_upload: "Upload",
    em_box_content: "Box Content:",
    em_show_box: "Show",
    em_slider_preview: "Slider Preview",
    em_org_placeholder: "Organization address or information",
    em_swal_title: "Remove the image and its related data.",
    em_swal_text: "You are sure?",
    em_swal_confirm: "Yes, remove it!",
    em_error_upload: "Image upload failed, please try again.",

    // editPicProfile
    ep_profile_picture: "Profile Picture:",
    ep_hide_picture: "Hide Picture",

    // editBtns_action
    eb_buttons_action: "Buttons Action:",
    eb_background: "Background:",
    eb_ok: "Ok",
    eb_text_color: "Text:",
    eb_save_color: "Save Color",
    eb_not_available_tpl: "Not available for this template",
    eb_label: "Label:",
    eb_type: "Type:",
    eb_value: "Value:",
    eb_system_action: "System Action Add to Contact",
    eb_custom_action: "Custom Action Link",

    // editColorTheme
    ect_color_theme: "Color Theme:",
    ect_bg_type: "Background Type",
    ect_color: "Color",
    ect_gradient: "Gradient",
    ect_image: "Image",
    ect_inactive: "(Inactive)",
    ect_bg_desc: "Choose the background type for your template. You can use a single color, a 2-color gradient, or an image.",
    ect_bg_color: "Background Color (RGBA)",
    ect_gradient_1: "Gradient Color 1 (RGBA)",
    ect_gradient_2: "Gradient Color 2 (RGBA)",
    ect_bg_image: "Background Image",
    ect_allowed_formats: "Allowed formats: .jpg, .jpeg, .png",
    ect_submit: "Submit",
    ect_invalid_file_title: "Invalid file",
    ect_invalid_file_text: "Only .jpg, .jpeg, and .png files are allowed.",
    ect_fail_load: "Failed to load color theme",

    // editContactMe
    ecm_contact_us: "Contact Us:",
    ecm_about_me: "About Me",
    ecm_phone_ph: "Your phone number, e.g., 234567890",
    ecm_email_ph: "Your email address, e.g., example@example.com",
    ecm_address_ph: "Your address, e.g., 123 Main St",
    ecm_about_ph: "Write something about you...",

    // editCover
    ecov_cover_picture: "Cover Picture:",
    ecov_image: "Image:",
    ecov_overlay: "Overlay:",
    ecov_bg_color: "Background Color",
    ecov_image_bg: "Image Background",
    ecov_video_bg: "Video Background",
    ecov_video: "Video:",
    ecov_audio: "Audio:",
    ecov_upload_image: "Upload Image",
    ecov_upload_video: "Upload Video",
    ecov_video_too_large: "Video weighs more than 50 mb",
    ecov_create_video: "Create video:",
    ecov_choose_images: "Choose your images",
    ecov_create_video_desc: "Create your own video with your preferred images.",
    ecov_create_video_limit: "( MAX 5, MIN 2 IMG)",
    ecov_setting_bg_video: "Setting background with video",
    ecov_could_not_create: "Could not create video, try later.",
    ecov_error_uploading: "Error uploading file.",

    // editFontFamily
    eff_font_family: "Font Family:",
    eff_preview: "Preview",
    eff_select_font: "Select Font:",
    eff_default: "Default",
    eff_custom_fonts: "Custom Fonts",
    eff_google_fonts: "Google Fonts",
    eff_fail_save_font: "Failed to save font",

    // editTemplate
    etpl_choose_template: "Choose Template",
    etpl_classic_grid: "Classic grid",
    etpl_nightly: "Nightly",
    etpl_jaglow: "Jaglow",
    etpl_postorg: "Postorg",
    etpl_bmenu: "bMenu",
    etpl_bstore: "bStore",
    etpl_events: "Events",
    etpl_about_me: "About me",
}
